import { createSelector } from 'reselect';

import { getProgramsCategory } from './programsCategory.selectors';

export const selectMiCoverageSchema = createSelector(
  getProgramsCategory,
  ({ miCoverageSchema }) => miCoverageSchema,
);
